import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from '../../Deliveries.module.css';
import TextInput from '../../../ReusableComponents/TextInput/TextInput';

class SearchSelectablePurchaseOrders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  handleSearch({ target: { value } }) {
    const { setSearch } = this.props;
    this.setState({ search: value }, () => setSearch(value));
  }

  render() {
    const { search } = this.state;

    return (
      <TextInput
        onChange={this.handleSearch}
        className={styles.purchaseOrderSearch}
        value={search}
        label="Search"
      />
    );
  }
}

SearchSelectablePurchaseOrders.propTypes = {
  setSearch: PropTypes.func.isRequired,
};

export default SearchSelectablePurchaseOrders;
